import { Link } from "@mui/material";
import React from "react";

/**
 * テキスト内のURLをクリック可能なリンクに変換する
 * URLが長い場合（30文字以上）は省略表示する
 * @param {string} text - 変換対象のテキスト
 * @param {number} maxLength - URLの最大表示長（デフォルト: 30文字）
 * @returns {Array} 変換されたテキストとリンクの配列
 */
export function convertTextWithLinks(text, maxLength = 30) {
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  return text.split(urlRegex).map((part, index) => {
    if (!urlRegex.test(part)) {
      return part;
    }

    let displayText = part;
    if (part.length > maxLength) {
      displayText = part.substring(0, maxLength - 3) + "...";
    }

    return (
      <Link key={index} href={part} target="_blank" rel="noopener noreferrer">
        {displayText}
      </Link>
    );
  });
}
